export default {
  tabs: {
    gift_cards: 'Cartes cadeau',
    settings: 'Paramètres',
  },
  gift_cards: {
    title: 'Cartes cadeau',
    subtitle: 'Gérez toutes les cartes cadeau de votre restaurant',
    buttons: {
      create: 'Créer une carte cadeau',
      redeem: 'Utiliser une carte cadeau',
      check_balance: 'Vérifier le solde',
    },
    search: {
      placeholder: 'Saisir le texte de recherche',
    },
    columns: {
      code: 'Code',
      status: 'Statut',
      balance: 'Solde',
      value: 'Valeur',
      email: 'Acheteur',
      source: 'Source',
      created_at: 'Créé',
    },
    statuses: {
      active: 'Actif',
      partially_redeemed: 'Partiellement utilisé',
      redeemed: 'Utilisé',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Paramètres des cartes cadeau',
      subtitle: 'Configurez les options de carte cadeau pour votre restaurant',
      availability: {
        title: 'Activer les cartes cadeau',
        subtitle: "Permettez aux clients d'acheter et d'utiliser des cartes cadeau",
        buttons: {
          enable: 'Activer',
          disable: 'Désactiver',
        },
      },
    },
    redemption_options: {
      title: "Options d'utilisation",
      subtitle: 'Choisissez où les clients peuvent utiliser les cartes cadeau',
      redemption_mode: {
        title: "Mode d'utilisation",
        subtitle: 'Cela affecte le texte affiché sur votre page carte cadeau',
        buttons: {
          online: 'En ligne uniquement',
          online_and_store: 'En ligne & En magasin',
        },
      },
    },
  },
  summary: {
    total_value: 'Valeur totale',
    total_active: 'Total actif',
    redeemed_this_month: 'Utilisés ce mois-ci',
  },
};
